const parseAllZones = (cookies, appCtx, isValidFn, logger) => {
  let result = { expressZones: [], standardZones: [] };

  if (isValidFn(cookies.zonesList)) {
    try {
      const base64Regex = /^[A-Za-z0-9+/=]+$/;
      if (!base64Regex.test(cookies.zonesList)) {
        throw new Error('Invalid Base64 format');
      }
      const decodedZones = Buffer.from(cookies.zonesList, 'base64').toString();
      const parsedZones = JSON.parse(decodedZones);

      result = {
        expressZones: Array.isArray(parsedZones.expressZones) ? parsedZones.expressZones : [],
        standardZones: Array.isArray(parsedZones.standardZones) ? parsedZones.standardZones : [],
      };
    } catch (error) {
      logger.error(`Error parsing zonesList: ${error.message}`);
    }
  }

  return result;
};

const parseZones = (isValidFn) => (rawZones) => {
  if (!isValidFn(rawZones)) return [];

  if (typeof rawZones !== 'string') {
    return [];
  }
  try {
    const arr = JSON.parse(rawZones);
    if (!Array.isArray(arr)) {
      return [];
    }
    return arr.filter((z) => typeof z === 'string' && z.trim().length > 0);
  } catch {
    return [];
  }
};

const validateFields = (isValidFn) => (keys) => (obj) => keys.every((key) => isValidFn(obj[key]));

export { parseAllZones, validateFields, parseZones };
